import React from "react";
import LearnersTable from "@/components/tables/LearnersTable";
import "@/components/Chart/chart"; // <-- important (side-effect import)
import LearnersExperienceLevelChart from "./LearnersExperienceLevelChart";
import LearnersInterestsChart from "./LearnersInterestsChart"
import SuggestedCoursesContainer from "./SuggestedCourses";


type LearnersOverviewProps = {
  digitalInterests: any[];
  experienceLevels: any[];
  recommendedCourses: any[];
  isFacilitator: boolean;
};


const LearnersOverview: React.FC<LearnersOverviewProps> = ({ digitalInterests, experienceLevels, recommendedCourses, isFacilitator }) => {
  return (
    <div className="learners-container">
      <div className="table-section">
        <LearnersTable isFacilitator={isFacilitator} />
      </div>
      <div className="charts-row">
        <LearnersExperienceLevelChart
          items={experienceLevels}
        />
        <LearnersInterestsChart
          height={400}
          items={digitalInterests}
        />
      </div>
      <div className="suggested-courses-container">
        <SuggestedCoursesContainer courses={recommendedCourses} userType="Facilitator" />
      </div>
    </div>
  );
};

export default LearnersOverview;
